import { useOutletContext } from 'react-router';
import { useReportByCategory } from '../api/reports';
import { LastUpdated } from '../components/LastUpdated';
import { Money } from '../components/Money';
import type { SalesContext } from './Sales';

export function SalesByCategory() {
  const { eventId, range } = useOutletContext<SalesContext>();
  const { data, isLoading, isError, dataUpdatedAt } = useReportByCategory(eventId, range);

  if (isLoading) return <div style={{ color: 'var(--fg-3)' }}>Loading…</div>;
  if (isError || !data) return <div className="form-error">Couldn't load category report.</div>;
  if (data.length === 0) {
    return (
      <div>
        <div style={{ color: 'var(--fg-3)' }}>No sales in this window.</div>
        <LastUpdated dataUpdatedAt={dataUpdatedAt} />
      </div>
    );
  }

  return (
    <div>
      <div className="card" style={{ overflow: 'hidden' }}>
      <table className="tbl">
        <thead>
          <tr>
            <th>Category</th>
            <th className="num">Qty sold</th>
            <th className="num">Gross</th>
            <th className="num">Refunded</th>
            <th className="num">Net</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.categoryId ?? '__custom'}>
              <td>{row.categoryName}</td>
              <td className="num">{row.qtySold}</td>
              <td className="num">
                <Money value={row.grossCents / 100} />
              </td>
              <td className="num">
                <Money value={row.refundedCents / 100} />
              </td>
              <td className="num">
                <Money value={row.netCents / 100} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      <LastUpdated dataUpdatedAt={dataUpdatedAt} />
    </div>
  );
}
